import EditIcon from '@mui/icons-material/Edit'
import { IconButton, TextField } from '@mui/material'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { patchCohort } from 'services/cohortServices'

const EditCohortNameButton = ({ cohortSession, successCallback }) => {
  const { t } = useTranslation()
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [cohortName, setCohortName] = useState(cohortSession.cohortName)
  const [requestError, setRequestError] = useState(null)

  const handleClose = async confirmed => {
    if (confirmed) {
      if (cohortName !== cohortSession.cohortName) {
        const res = await patchCohort(cohortSession.cohortId, { name: cohortName })
        if (res.status === 200) {
          successCallback(cohortName)
          setRequestError(false)
          setEditDialogOpen(false)
        } else {
          setRequestError(true)
        }
      }
    } else {
      setEditDialogOpen(false)
    }
  }
  return (
    <>
      <IconButton
        title={t('common.edit')}
        onClick={() => setEditDialogOpen(true)}>
        <EditIcon fontSize='small' />
      </IconButton>
      <CommonDialog
        open={editDialogOpen}
        onClose={handleClose}
        titleText={`${t('common.edit')} ${t('overview.cohort')}`}
        confirmText={t('common.save')}
        cancelText={t('common.cancel')}>
        <TextField
          value={cohortName}
          onChange={e => setCohortName(e.target.value)}
        />
        {requestError && <RequestRetryAlert />}
      </CommonDialog>
    </>
  )
}

export default EditCohortNameButton
